<template>
    <div>
        <v-text-field v-model="search"
                      dense
                      outlined
                      label="جستجو"
                      class="col-md-4"
                      :clearable="this.editNum==null"
                      clear-icon="mdi-close-circle-outline"
        ></v-text-field>

        <divar-advertise :search-results="advertises"></divar-advertise>

        <div ref="scroll"></div>
    </div>
</template>

<script>
import DivarAdvertise from "../../../../components/divarAdvertise";

export default {
    name: "relatedAdvertise",
    components: {DivarAdvertise},
    props: {
        related_id: {
            require: true
        }
    },
    data() {
        return {
            advertises: [],
            next_page: null,
            observer: null,
            search: null,
            timer: null,
        }
    },
    methods: {
        getAdvertises(url) {
            $.ajax({
                url: url,
                method: 'GET',
                fn: this.deleteAction,
                data: {
                    q: this.search
                },
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: (res) => {
                    this.advertises = this.advertises.concat(res.data.data.map(x => x.payload));
                    this.next_page = res.data.next_page_url;

                    if (this.next_page)
                        this.observer.observe(this.$refs.scroll);
                },
            });
        }
    },
    watch: {
        search() {
            clearTimeout(this.timer);

            this.timer = setTimeout(() => {
                this.advertises = [];
                this.next_page = null;
                this.getAdvertises(`${url}/smarts/related/new/${this.related_id}`);
            }, 700);
        }
    },
    mounted() {
        this.getAdvertises(`${url}/smarts/related/new/${this.related_id}`);

        this.observer = new IntersectionObserver((entries => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.getAdvertises(this.next_page);
                    this.observer.unobserve(this.$refs.scroll);
                }
            })
        }))
    }
}
</script>

<style scoped>

</style>